import type { ClientOptions, SSRData } from '@urql/core'
import { provideClient } from '@urql/vue'

const SSR_KEY = '__URQL_DATA__'

export default defineNuxtPlugin(async (nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()
  const isTesting = useIsTesting()
  const getServiceHref = useGetServiceHref()
  const { csrf } = useCsrf()
  const cookie = useRequestHeader('cookie')

  const baseUrl = getServiceHref({
    name: SITE_NAME,
  })
  const clientOptions: Partial<ClientOptions> = {
    fetchOptions: {
      headers: {
        [CSRF_HEADER_NAME]: csrf,
        ...(cookie ? { cookie } : {}),
      },
    },
  }

  const { ssrExchange, urql, urqlTesting, urqlCache, urqlReset } =
    await getUrqlClient({
      baseUrl,
      clientOptions,
      runtimeConfig,
    })

  if (import.meta.client) {
    nuxtApp.hook('app:created', () => {
      ssrExchange.restoreData(nuxtApp.payload[SSR_KEY] as SSRData)
    })
  }

  if (import.meta.server) {
    nuxtApp.hook('app:rendered', () => {
      nuxtApp.payload[SSR_KEY] = ssrExchange.extractData()
    })
  }

  nuxtApp.hook('vue:setup', () => {
    const { $urql } = useNuxtApp()
    provideClient($urql)
  })

  return {
    provide: {
      urql: isTesting ? urqlTesting : urql,
      urqlCache,
      urqlReset,
    },
  }
})
